import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FaQModel } from '../../models/faq.model';
import { FindSolutionModel} from '../../models/issue.model';
import { CommunicationService } from '../../services/communication.service';
import { FaqService } from '../../services/faq.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {

  searchFaQKey : string;
  thisDataFaQ :  FindSolutionModel[]; //FaQModel [];
  commSubsription: Subscription;
  constructor( 
    private fservice : FaqService,
    private commservice : CommunicationService) { 

        this.commSubsription = commservice.issueTransfer.subscribe(data => {
          
          console.log("SidebarComponent : issueTransfer : " + data);
          this.commservice.sendTag(true);

          this.searchFaQKey = data.issue;
          this.onSearchFaQ();
        
        });
    }

  ngOnInit() {
  }

  ngOnDestroy()
  {
    console.log("ngOnDestroy : SidebarComponent ");
    if( this.commSubsription) {
      this.commSubsription.unsubscribe();
      this.commSubsription = null;
    } 
  }
  onSidebarClose()
  {
    this.commservice.sendTag(false);
  }

// Search For KB
  onSearchFaQ(){

    if(this.searchFaQKey == null || this.searchFaQKey.length < 3)
    {
      alert("Please input more than 3 characters.");
      return;
    }
    console.log("onSearchKB" + ":" + this.searchFaQKey);
    
    this.fservice.findData(this.searchFaQKey).subscribe(
      res=>{
       // this.thisDataFaQ = res as FaQModel[];
        this.thisDataFaQ = res as FindSolutionModel[];
        console.log(this.thisDataFaQ);
      },
      err=>{}
    );
  }

  onSearchClearFaQ()
  {
    console.log("onSearchClearFaQ");
    this.searchFaQKey = "";
    this.thisDataFaQ = null;
    
  }
/*
  onSelectFaQ(item)
  {
    var url = this.router.serializeUrl(
      this.router.createUrlTree(['/faqpopup'])
    );

    //var strWindowFeatures = "menubar=no,location=no,resizable=no,scrollbars=no,status=yes,width=400,height=350";
    var strWindowFeatures = "width=400,height=350";

    console.log("onSelectFaQ :" +  url + ":"+ item.faqId);
    window.open(url + "?id=" + item.faqId, '_blank', strWindowFeatures);
  }*/
}
